import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { PushService } from '../service/PushService';

import { HomePage } from '../pages/home/home';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = HomePage;

  constructor(pushService:PushService, platform: Platform) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      pushService.init();
    });
    platform.resume.subscribe(() => {
      console.log("verificandoAjax:MyApp:resume");
      pushService.checkMsgServer().then((lastMsg) => {
        pushService.onProcessLastMessage(lastMsg, "LOAD");
      });
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts